export enum CurrencyName {
  RPT = 'RPT',
  RPV = 'RPV',
  BNB = 'BNB',
  ETH = 'ETH',
}
